var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("h3", { staticClass: "card-header regular s-bold text-light-gray" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("settings.themeTab.uploadLogo")) + "\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-block p-4" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              {
                staticClass: "text-center",
                attrs: { id: "theme-logo-container" },
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  staticStyle: { border: "1px solid #d3d4db" },
                  attrs: {
                    id: "theme-logo",
                    src: _vm.logo,
                    alt: _vm.$t("global.words.filogixLogo"),
                  },
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "justify-content-center mb-md-0 mb-4 mt-4" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row justify-content-center offset-md-3 col-md-3 offset-sm-2 col-sm-4 col-xl-6 offset-lg-0 col-lg-12 mb-2 mb-xl-0",
              },
              [
                _c(
                  "simple-button",
                  {
                    attrs: {
                      type: "primary btn-sm",
                      loading: _vm.uploadingLogo.loading,
                      "loading-succeeded": _vm.uploadingLogo.status,
                    },
                    on: { click: _vm.handleClickUploadLogo },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("settings.themeTab.uploadPhoto")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "d-none",
                  attrs: {
                    id: "selected-image",
                    accept: "image/x-png,image/gif,image/jpeg,image/svg+xml",
                    type: "file",
                  },
                  on: { change: _vm.handleChangeLogo },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "selected-image", hidden: "" } }, [
                  _vm._v("Selected Image"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center col-md-3 col-sm-4 col-lg-12 col-xl-6 mb-lg-2 mb-xl-0",
              },
              [
                _c(
                  "simple-button",
                  {
                    attrs: {
                      type: "white btn-sm",
                      loading: _vm.removingLogo.loading,
                      "loading-succeeded": _vm.removingLogo.status,
                    },
                    on: { click: _vm.removeLogo },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("settings.themeTab.removePhoto")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }